/**
 * Created by koqiui on 2017-04-12.
 */
import api from './index';

let exports = {};

exports.getMsuListByDistAllowedIsTrue = function (params, callback) {// 供应上允许服务商申请的 渠道msu列表
    api.post('/servc/msu/list/get/by/unDistAllowed')
    .data(params)
    .done(callback)
    .go();
};

//渠道服务列表
exports.getMsuPagedListByContext = function (params, callback) {// 服务商的MSU列表
    api.post('/servc/msu/paged/list/get/by/context')
    .data(params)
    .done(callback)
    .go();
};

// 服务中提取-服务类型
exports.getServcTypeList = function (params, callback) {
    api.get('/servc/type/list/get')
    .params(params)
    .done(callback)
    .fail(callback)
    .go();
};
//查询服务列表
exports.getServcList = function (data, callback) {// 获取服务列表
    api.post('/servc/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 导出服务项目列表
exports.servcExportUrl = function (data, callback) {// 导出服务项目列表
    api.post('/servc/export/url')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 导出要导入的全部服务项目数据
exports.exportServcImpModelUrl = function (data, callback) {// 导出要导入的全部服务项目数据
    api.post('/servc/imp/model/for/export/url')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 验证/修正服务项目导入数据
exports.validateServcImpInfo = function (data, callback) {// 验证/修正服务项目导入数据
    api.post('/servc/imp/validate')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 服务项目导入
exports.doServcImpInfoImport = function (data, callback) {// 服务项目导入
    api.post('/servc/imp/info/import/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
//查询服务(自营和渠道)列表
exports.getServcListByGoodsCatId = function (data, callback) {// 获取服务列表
    api.post('/servc/list/get/by/goodsCatId')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

exports.getServcChargeItemList = function (data, callback) {// 服务收费项
    api.post('/servc/charge/item/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

exports.saveServcChargeItemList = function (data, callback) {// 设置服务收费项
    api.post('/servc/charge/item/list/save/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

exports.deleteServcChargeItem = function (data, callback) {// 移除服务收费项
    api.post('/servc/charge/item/delete/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

// ================================= 服务视频 ====================================

exports.getServcVideoList = function (data, callback) {// 获取-服务视频
    api.post('/servc/video/list/get')
    .data(data)
    .done(callback)
    .go();
};

exports.saveServcVideo = function (data, callback) {// 保存-服务视频
    api.post('/servc/video/save')
    .data(data)
    .done(callback)
    .go();
};

exports.deleteServcVideo = function (params, callback) {// 删除-服务视频
    api.post('/servc/video/delete')
    .params(params)
    .done(callback)
    .go();
};

exports.getMsuInfo = function (postData, callback) {
    api.get('/servc/msu/info/get')
    .params(postData)
    .done(callback)
    .go();
};

// 我的授权服务列表
exports.getAuthOutMsuPagedList = function (postData, callback) {
    api.post('/servc/auth/msu/out/list/get')
    .data(postData)
    .done(callback)
    .go();
};
// 新增授权-服务
exports.saveAuthMsuInfo = function (postData, callback) {
    api.post('/servc/auth/msu/save/get')
    .data(postData)
    .done(callback)
    .go();
};
// 修改授权-服务
exports.updateAuthMsuInfo = function (postData, callback) {
    api.post('/servc/msu/update/info/do')
    .data(postData)
    .done(callback)
    .go();
};

// 删除MSU-服务
exports.deleteMsuInfo = function (postData, callback) {
    api.post('/servc/msu/delte/do')
    .data(postData)
    .done(callback)
    .go();
};

// msu 列表
exports.getMsuPagedList = function (postData, callback) {// 查询MSU列表
    api.post('/servc/msu/paged/list/get')
    .data(postData)
    .done(callback)
    .go();
};
// 上下架设置
exports.updateMsuShelfState = function (postData, callback) {// 服务上下架设置
    api.post('/servc/msu/shelfState/update/do')
    .data(postData)
    .done(callback)
    .go();
};

// =======================服务销售人员 ===================
exports.updateMsuXsStaffId = function (data, callback) {// 设置服务销售人员
    api.post('/servc/update/msu/xsStaffId/do')
    .data(data)
    .done(callback)
    .go();
};
exports.deleteMsuXsStaffId = function (data, callback) {// 删除-服务销售人员
    api.post('/servc/delete/msu/xsStaffId/do')
    .data(data)
    .done(callback)
    .go();
};

// ================ 服务介绍 ====================
exports.getServcIntroByServcId = function (data, callback) {// 根据服务Id获取服务介绍
    api.post('/servc/intro/get/by/servcId')
    .data(data)
    .done(callback)
    .go();
};

//保存服务
exports.saveServc = function (postData, callback) {// 保存服务信息
    api.post('/servc/save/do')
    .data(postData)
    .done(callback)
    .go();
};

//根据id查询服务
exports.getServcInfo = function (postData, callback) {// 根据ID获取服务信息
    api.post('/servc/info/get')
    .data(postData)
    .done(callback)
    .go();
};

//更新服务
exports.updateServc = function (postData, callback) {// 更新服务信息
    api.post('/servc/update/do')
    .data(postData)
    .done(callback)
    .go();
};

//保存商品_服务（关联关系)
exports.saveGoodsServc = function (postData, callback) {// 保存商品_服务（关联关系)
    api.post('/servc/goods/servc/save/do')
    .data(postData)
    .done(callback)
    .go();
};

//删除商品_服务（关联关系)
exports.deleteGoodsServc = function (postData, callback) {// 删除商品_服务（关联关系)
    api.post('/servc/goods/servc/delete/do')
    .data(postData)
    .done(callback)
    .go();
};

//更新Msu
exports.updateMsu = function (postData, callback) {// 更新MSU信息
    api.post('/servc/msu/update/do')
    .data(postData)
    .done(callback)
    .go();
};

//解除合同
exports.relieveContract = function (postParam, callback) {// 解除合同
    api.post('/servc/contract/relieve/do')
    .params(postParam)
    .done(callback)
    .go();
};

//上架时更新Msu价格
exports.updateMsuByPrice = function (postData, callback) {// 上架时更新Msu价格
    api.post('/servc/msu/price/update/do')
    .data(postData)
    .done(callback)
    .go();
};

// 获取服务的属性值
exports.getServcAttrValListByServcId = function (postData, callback) {// 获取服务的属性值
    api.post('/servc/attr/val/list/get/by/servcId')
    .data(postData)
    .done(callback)
    .go();
};

// 获取服务的属性值
exports.saveServcSellRegion = function (postData, callback) {// 保存服务区域信息
    api.post('/servc/sell/region/save/do')
    .data(postData)
    .done(callback)
    .go();
};

// msu 列表
exports.getMsuListByContext = function (postData, callback) {// 根据上下文获取MSU列表
    api.post('/servc/msu/list/get/by/context')
    .data(postData)
    .done(callback)
    .go();
};
// msu 列表
exports.getServcGoodsCatRelList = function (postParam, callback) {// 根据上下文获取MSU列表
    api.get('/servc/goods/cat/rel/list/get')
    .params(postParam)
    .done(callback)
    .go();
};

exports.getMsuListByGoodsIdAndServicerId = function (postData, callback) {// 获取MSU列表
    api.post('/servc/msu/list/get/by/goodsCatId/and/servicerId')
    .data(postData)
    .done(callback)
    .go();
};

exports.getMsuListByGoodsIdAndMerchantIdAndMerchantType = function (postData, callback) {// 获取MSU列表
    api.post('/servc/msu/list/get/by/goodsId/and/merchantId')
    .data(postData)
    .done(callback)
    .go();
};

exports.getAuthServicerListBySsu = function (postParam, callback) {
    api.get('/servc/auth/servicer/list/by/ssu/get')
    .params(postParam)
    .done(callback)
    .go();
};

exports.getAuthServicerNameListBySsu = function (postParam, callback) {
    api.get('/servc/auth/servicer/name/list/by/ssu/get')
    .params(postParam)
    .done(callback)
    .go();
};
exports.getMsuByUK = function (postParam, callback) {
    api.post('/servc/msu/by/uk/get')
    .data(postParam)
    .done(callback)
    .go();
};
export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/servc.js
// module id = 24
// module chunks = 1